<script setup>
import { computed, defineProps } from 'vue';
import UnitMap from '@/components/maps/UnitMap.vue';

const props = defineProps({
  widget: {
    type: Object,
    required: true
  },
  dataID: {
    type: String,
    required: true
  },
  timeFormat: {
    type: String,
    default: '24hour'
  },
  sourceErrors: {
    type: Object,
    default: () => ({})
  }
});

const sourceNotFound = computed(() =>
  props.sourceErrors?.[props.widget.source]?.type === 'not_found'
    ? props.widget.source : null
);

// Convert widget config to template format
const mapTemplate = computed(() => {
  const { title, ...config } = props.widget;
  return { ...config, title };
});
</script>

<template>
  <div class="relative w-full h-full">
    <UnitMap
      :dataID="dataID"
      :template="mapTemplate"
      :timeFormat="timeFormat"
    />
    <div
      v-if="sourceNotFound"
      class="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-mc-cloud/90 dark:bg-mc-charcoal/90 backdrop-blur-sm rounded-mc-sm"
    >
      <p class="font-body text-tier-2 text-mc-red font-medium">Source Not Found</p>
      <p class="font-mono text-[11px] uppercase tracking-[0.12em] text-ink-muted dark:text-on-dark-muted">{{ sourceNotFound }}</p>
    </div>
  </div>
</template>
